import * as SwiperElement from 'swiper/element/bundle'
import noUiSlider from 'nouislider'
import { xMaska } from "maska/alpine"
import Alpine from 'alpinejs'

window.noUiSlider = noUiSlider

// Alpine plugins
import focus from '@alpinejs/focus'
import mask from '@alpinejs/mask'
import persist from '@alpinejs/persist'

// Alpine custom plugins
import accordion from './alpine-plugins/accordion'
import collapse from './alpine-plugins/collapse'

// Alpine magics
import maxMediaMatches from './alpine-maigcs/max-media-matches'

// Alpine components
import alpineComponents from './alpine-components'

// Alpine stores
import productNav from './alpine-stores/product-nav'
import creditApplicationDraft from './alpine-stores/credit-application-draft'

window.Alpine = Alpine

SwiperElement.register()
Alpine.plugin(mask)
Alpine.plugin(xMaska)
Alpine.plugin(focus)
Alpine.plugin(persist)
Alpine.plugin(accordion)
Alpine.plugin(collapse)
Alpine.plugin(maxMediaMatches)
Alpine.plugin(alpineComponents)
Alpine.plugin(productNav)
Alpine.plugin(creditApplicationDraft)

// Alpine.start() in app.js

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// import Pusher from 'pusher-js'
// window.Pusher = Pusher

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// })
